// @ts-nocheck
import * as React from 'react';
import { useEffect } from 'react';
import logo1 from '../../images/newTitleOrb.png';
import logo2 from '../../images/login_bg1.jpg';
import OrbcommLogo11 from '../../images/ORBCOMMLOGOR.svg';

const Azuresignout = () => {
    var preloader = document.getElementById("preloader");
    preloader.classList.add("hidden");
    useEffect(() => {
        sessionStorage.removeItem("UserInfo");
        sessionStorage.removeItem("root");
        sessionStorage.removeItem('QueryTag');
        if (localStorage.length > 0) {
            localStorage.clear();
        }
        if (sessionStorage.length > 0) {
            sessionStorage.clear();
        }

    }, []);

    const RedirectToRC = () => {      
        window.location.href = "/";
    };

    var divStyle = {
        backgroundImage: `url(${logo2})`
    }

    return (

        <div className='login-bg img-responsive' style={divStyle}>
            <div className='login-form'>
                <div>
                    <div className='login-page-line'></div>
                    <div className='login-logo-maritime'>
                        <img src={OrbcommLogo11} alt="Maritime platform" className='login-page-logo' />
                        <span className='login-maritime'> MARITIME </span>
                    </div>
                </div>

                <div className='SignOutText'>You have been successfully signed out!</div>
                {sessionStorage.getItem('AZRD') == null ? <a className="SignInAgainText" onClick={RedirectToRC}> Click here to sign in again </a> : ''}


            </div>
            <div className='login-footer'><span>© ORBCOMM All Rights Reserved</span></div>
        </div>
    );
};

export default Azuresignout;
